import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 400 400"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M199.999 200q-27.5 0-47.083-19.583-19.584-19.584-19.583-47.083 0-27.5 19.583-47.084 19.584-19.583 47.083-19.583 27.5 0 47.084 19.583 19.583 19.584 19.583 47.084t-19.583 47.083Q227.499 200.001 199.999 200M66.666 333.334v-46.667q0-14.166 7.292-26.042 7.291-11.874 19.375-18.125 25.833-12.916 52.5-19.375a229.3 229.3 0 0 1 54.166-6.458q27.5 0 54.167 6.458t52.5 19.375q12.084 6.25 19.375 18.125t7.292 26.042v46.667z"
    }, null, -1)
  ])))
}
export default { render: render }